import { AlertTriangle, CheckCircle2 } from "lucide-react";

const STEPS = [
  ["Type on the laptop keyboard into the line above.", "If letters appear, this page is fine - the emulator is simply not typing into the browser."],
  ["System Settings → Privacy & Security → Accessibility.", "nfc-keyboard-emulator must be ON. If it already is, switch it OFF and ON again (macOS silently drops it after app updates), then quit and reopen the emulator."],
  ["In the emulator, switch \"Typing active\" on and set the trailing key to Enter.", "Then click once on this browser window so it is the frontmost app, and scan again."],
  ["Still nothing? Use the reader bridge below.", "It reads the ACR1252U directly and needs none of the above."],
];

export const ReaderHelp = ({ keys, lastKeyAt, bridgeOnline }) => {
  const healthy = keys > 0 || bridgeOnline;
  if (healthy) {
    const how = bridgeOnline ? "reader bridge connected" : `keystrokes arriving${lastKeyAt ? ` · last ${Math.round((Date.now() - lastKeyAt) / 1000)}s ago` : ""}`;
    return (
      <p data-testid="reader-help" data-state="ok" className="mt-4 flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-emerald-300">
        <CheckCircle2 size={14} /> Reader path OK · {how}
      </p>
    );
  }
  return (
    <div data-testid="reader-help" data-state="waiting" className="mt-4 border border-amber-300/40 bg-amber-300/5 p-4">
      <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-amber-300">
        <AlertTriangle size={14} /> No keystrokes received yet
      </p>
      <p className="mt-2 text-sm text-slate-300">
        The reader beeps and the emulator shows the tag, but nothing reaches this page? That means the keystrokes are being
        blocked on the Mac itself. Work down this list:
      </p>
      <ol className="mt-3 grid gap-2 text-sm">
        {STEPS.map(([title, detail], i) => (
          <li key={title} data-testid={`reader-help-step-${i + 1}`} className="grid grid-cols-[24px_1fr] gap-2">
            <span className="font-mono text-amber-300">{i + 1}.</span>
            <span><span className="text-slate-100">{title}</span> <span className="text-slate-400">{detail}</span></span>
          </li>
        ))}
      </ol>
    </div>
  );
};
